import axios from "@/axios";

export default {
  namespaced: true,
  state: {
    loading: false,
    providers: [],
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    providers(state) {
      return state.providers;
    },
  },
  mutations: {
    RESET(state) {
      state.loading = false;
      state.providers = [];
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_PROVIDERS(state, payload) {
      state.providers = payload;
    },
  },
  actions: {
    reset({ commit }) {
      commit("RESET");
    },
    fetchProviders({ commit }, payload = { pagination: false, sort: "asc" }) {
      commit("SET_LOADING", true);

      let url = "/providers?";
      if ("pagination" in payload) url += `pagination=${payload.pagination}`;

      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then((response) => {
            commit("SET_PROVIDERS", response.data["hydra:member"]);
            resolve(response);
          })
          .catch((error) => {
            reject(error.response.data);
            // TODO: Log error in Sentry
          })
          .finally(() => commit("SET_LOADING", false));
      });
    },
  },
};
